import { container, title } from "assets/jss/material-kit-react.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-kit-react/customCheckboxRadioSwitch.jsx";
import {
    successColor,
} from "assets/jss/material-dashboard-react.jsx";


const basicsStyle = {
    container,
    title: {
        ...title,
        marginTop: "30px",
        minHeight: "32px",
        textDecoration: "none"
    },
    icons: {
        width: "17px",
        height: "17px",
        color: "#FFFFFF"
    },
    headerButton: {
        margin: "1.12em 0",
    },
    cardCategory: {
        color: "#999999",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        paddingTop: "10px",
        marginBottom: "0"
    },
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitle: {
        color: "#3C4858",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    chartContainer: {
        overflowX: "auto",
        "& svg": {
            minWidth: "700px",
        },
        "& .ct-grid": {
            stroke: "rgba(0, 0, 0, 0.2)"
        },
        "& .ct-label":{
            color: "rgba(0, 0, 0, 0.2)"
        },
        "& .ct-series-a .ct-point, .ct-series-a .ct-line, .ct-series-a .ct-bar, .ct-series-a .ct-slice-donut": {
            stroke: successColor,
        }
    },
    keyHashSpan: {
        fontFamily: "Roboto Mono, Helvetica Monospaced, monospace"
    },
    select: {
        width: "100%",
    },
    selectWrapper: {
        marginLeft: "20px",
        height: "58px",
        maxWidth: "192px",
        width: "100%",
    },
    tableButton: {
        height: "31px",
        margin: "0",
    },
    keySearchInput: {
        margin: "0 20px 0 0",
    },
    dateTime: {
        margin:"0 1em 1em 0"
    },
    waterRefillDiv: {
        display: "grid",
        textAlign: "center",
        "& button": {
            padding: "10px 15px",
        },
    },
    ...customCheckboxRadioSwitch
};

export default basicsStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-react/views/usersStyle.jsx